function getBundleProductTitle(bundleProduct) {
    var ref;
    if (!bundleProduct) {
        return;
    }
    if ((ref = bundleProduct.variants) === null || ref === void 0 ? void 0 : ref.length) {
        var ref1;
        const selected = (ref1 = bundleProduct.variants) === null || ref1 === void 0 ? void 0 : ref1.find((v)=>v.sku === bundleProduct.sku
        );
        // to prevent "title -"
        if (!selected || !(selected === null || selected === void 0 ? void 0 : selected.title)) {
            return bundleProduct.title;
        }
        return `${bundleProduct.title} - ${selected.title}`;
    } else {
        return bundleProduct.title;
    }
}

export { getBundleProductTitle };
//# sourceMappingURL=get-bundle-product-title.js.map
